import { useEffect } from 'react';

const useWindowResize = (callback?: () => void) => {
    let windowWidth = window.innerWidth;

    /**
     * iOS triggers a window resize when scrolling as it hides the address bar.
     * To prevent this, we check if the window width has actually changed.
     */
    const callbackWhenChanged = () => {
        if (windowWidth === window.innerWidth || !callback) {
            return;
        }

        windowWidth = window.innerWidth;
        callback();
    };

    useEffect(() => {
        window.addEventListener('resize', callbackWhenChanged);

        return () => window.removeEventListener('resize', callbackWhenChanged);
    }, [callback]);

    return windowWidth;
};

export default useWindowResize;
